module.exports = __webpack_public_path__ + "img/002.473e083a.png";